import React, {Component} from 'react';
import PropTypes from 'prop-types';

class UserAccessList extends Component {
  render() {
    return (
      <ul className="sites_list">
        {this.props.userNames.map((name, index) => {
          return <li key={index}>{name}</li>;
        })}
      </ul>
    );
  }
}

UserAccessList.propTypes = {
  userNames: PropTypes.array,
};

export default UserAccessList;
